import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "ariaLabel", "headingText", "subHeadline", "subHeadingText", "headingType", "headingTypeSubHeading", "descriptionText", "descriptionType", "textLocation", "cta", "styleType", "fontColor", "isHero", "isCurrentSlide", "isAlreadyWraped", "entryId"];
var __jsx = React.createElement;
import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import styles from './TextCard.style';
import RichText from '../../atoms/RichText/RichText';
import Para from '../../atoms/Para';
import Heading from '../../atoms/Heading';
import Anchor, { FakeAnchorStyled } from '../../atoms/Anchor';
import { siteConstants } from '../../../constants/globalConstants';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { marked } from 'marked';
var TextCard = function TextCard(_ref) {
  var _cta$sys, _cta$sys2, _cta$sys3, _cta$sys4;
  var className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    headingText = _ref.headingText,
    subHeadline = _ref.subHeadline,
    subHeadingText = _ref.subHeadingText,
    headingType = _ref.headingType,
    headingTypeSubHeading = _ref.headingTypeSubHeading,
    descriptionText = _ref.descriptionText,
    descriptionType = _ref.descriptionType,
    textLocation = _ref.textLocation,
    cta = _ref.cta,
    styleType = _ref.styleType,
    fontColor = _ref.fontColor,
    isHero = _ref.isHero,
    isCurrentSlide = _ref.isCurrentSlide,
    isAlreadyWraped = _ref.isAlreadyWraped,
    entryId = _ref.entryId,
    others = _objectWithoutProperties(_ref, _excluded);
  var multiLineHeadline;
  var multiLineSubHeadline;
  var _useState = useState(isHero && !isCurrentSlide ? false : true),
    shouldBeTabbable = _useState[0],
    setShouldBeTabbable = _useState[1];
  var TextCardContainer = useRef(null);
  useEffect(function () {
    var timer;
    if (isHero && TextCardContainer) {
      var newWidth = window.innerWidth;
      // makes all anchors in hero temporarely untabbable while slide is changing
      setShouldBeTabbable(false);
      // the dealy is to give time for slide to finish (the slider takes 1000 ms so I made this 1010)
      var delayInMilliseconds = 1010;
      timer = setTimeout(function () {
        var textCardBoundaries = TextCardContainer.current.getBoundingClientRect();
        setShouldBeTabbable(isCurrentSlide && textCardBoundaries.width > 0 && textCardBoundaries.left >= 0 && textCardBoundaries.right <= newWidth);
      }, delayInMilliseconds);
    }
    return function () {
      clearTimeout(timer);
    };
  }, [TextCardContainer, isCurrentSlide]);
  if (isHero) {
    // the regex is to prevent a user from hitting enter twice and
    // enging up with two </br> instead of one
    if (headingText && headingText.includes('\n')) {
      multiLineHeadline = headingText.trim().replace(/\n+/g, '\n').split('\n').map(function (line) {
        return line.trim();
      }).join('<br>');
    }
    if (subHeadingText && subHeadingText.includes('\n')) {
      multiLineSubHeadline = subHeadingText.trim().replace(/\n+/g, '\n').split('\n').map(function (line) {
        return line.trim();
      }).join('<br>');
    }
  }
  // Add support for <sup> tags in marked
  marked.use({
    extensions: [{
      name: 'superscript',
      level: 'inline',
      start: function start(src) {
        var _src$match;
        return (_src$match = src.match(/\^/)) === null || _src$match === void 0 ? void 0 : _src$match.index;
      },
      tokenizer: function tokenizer(src) {
        var rule = /^\^([^^\s]+)\^/;
        var match = rule.exec(src);
        if (match) {
          return {
            type: 'superscript',
            raw: match[0],
            text: match[1],
            tokens: []
          };
        }
      },
      renderer: function renderer(token) {
        return "<sup>".concat(token.text, "</sup>");
      }
    }]
  });
  return __jsx("div", {
    className: "nva-text-card ".concat(className),
    ref: TextCardContainer
  }, headingText && __jsx(Heading, _extends({
    HeadingType: headingType,
    className: "nva-text-card__header card-header"
  }, ContentfulLivePreview.getProps({
    entryId: entryId,
    fieldId: 'headline'
  })), cta && !isAlreadyWraped && styleType != 'heroCarousel' ? __jsx(Anchor, _extends({
    "data-entry-id": (_cta$sys = cta.sys) === null || _cta$sys === void 0 ? void 0 : _cta$sys.id,
    title: headingText,
    to: cta.url,
    hyperlinkType: cta.hyperlinkType,
    ctaBehavior: cta.behavior,
    "data-analytics-type": cta.anchorDataAnalyticsType,
    "data-analytics-value": cta.anchorDataAnalyticsValue,
    "data-analytics-variation": cta.anchorDataAnalyticsVariation,
    "aria-label": cta.ariaLabel
  }, others), headingText) : multiLineHeadline ? __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(Array.isArray(multiLineHeadline) ? multiLineHeadline.join('') : multiLineHeadline)
    }
  }) : __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(headingText)
    }
  })), subHeadline && __jsx(Heading, _extends({
    HeadingType: headingTypeSubHeading,
    className: "nva-text-card__sub-headline card-subHeading"
  }, ContentfulLivePreview.getProps({
    entryId: entryId,
    fieldId: 'subHeadline'
  })), subHeadline), subHeadingText && __jsx(Heading, _extends({
    HeadingType: headingTypeSubHeading,
    className: "nva-text-card__sub-heading-text card-subHeading"
  }, ContentfulLivePreview.getProps({
    entryId: entryId,
    fieldId: 'subHeadline'
  })), multiLineSubHeadline ? __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(Array.isArray(multiLineSubHeadline) ? multiLineSubHeadline.join('') : multiLineSubHeadline)
    }
  }) : __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(subHeadingText)
    }
  })), descriptionText && descriptionType && descriptionType === siteConstants.RICH_TEXT && (cta && !isAlreadyWraped && styleType != 'heroCarousel' ? __jsx(Anchor, _extends({
    "data-entry-id": (_cta$sys2 = cta.sys) === null || _cta$sys2 === void 0 ? void 0 : _cta$sys2.id,
    title: cta.label || 'rich text card',
    to: cta.url,
    hyperlinkType: cta.hyperlinkType,
    ctaBehavior: cta.behavior,
    "data-analytics-type": cta.anchorDataAnalyticsType,
    "data-analytics-value": cta.anchorDataAnalyticsValue,
    "data-analytics-variation": cta.anchorDataAnalyticsVariation,
    "aria-label": cta.ariaLabel
  }, others), __jsx(RichText, {
    className: "nva-text-card__description card-rich-text",
    jsonContent: descriptionText,
    contentfulLivePreview: ContentfulLivePreview.getProps({
      entryId: entryId,
      fieldId: 'textBlock'
    })
  })) : __jsx(RichText, {
    className: "nva-text-card__description card-rich-text",
    jsonContent: descriptionText,
    isHero: isHero,
    shouldBeTabbable: shouldBeTabbable,
    contentfulLivePreview: ContentfulLivePreview.getProps({
      entryId: entryId,
      fieldId: 'textBlock'
    })
  })), descriptionText && !descriptionType && __jsx(Para, {
    className: "nva-text-card__description para-cta-desc-wrapper"
  }, cta && !isAlreadyWraped ? __jsx(Anchor, _extends({
    "data-entry-id": (_cta$sys3 = cta.sys) === null || _cta$sys3 === void 0 ? void 0 : _cta$sys3.id,
    title: cta.label || descriptionText,
    to: cta.url,
    hyperlinkType: cta.hyperlinkType,
    ctaBehavior: cta.behavior,
    "data-analytics-type": cta.anchorDataAnalyticsType,
    "data-analytics-value": cta.anchorDataAnalyticsValue,
    "data-analytics-variation": cta.anchorDataAnalyticsVariation,
    "aria-label": cta.ariaLabel
  }, others, ContentfulLivePreview.getProps({
    entryId: entryId,
    fieldId: 'textBlock'
  })), descriptionText && descriptionText) : descriptionText ? descriptionText : ''), cta && !isAlreadyWraped && __jsx(Para, {
    className: "nva-text-card__cta para-cta-wrapper"
  }, __jsx(Anchor, _extends({
    "data-entry-id": (_cta$sys4 = cta.sys) === null || _cta$sys4 === void 0 ? void 0 : _cta$sys4.id,
    tabIndex: shouldBeTabbable ? '0' : '-1',
    title: cta.label,
    to: cta.url,
    hyperlinkType: cta.hyperlinkType,
    styleType: cta.styleType,
    type: cta.type,
    ctaBehavior: cta.behavior,
    className: styleType == 'heroCarousel' ? '' : 'arrow',
    "data-analytics-type": cta.anchorDataAnalyticsType,
    "data-analytics-value": cta.anchorDataAnalyticsValue,
    "data-analytics-variation": cta.anchorDataAnalyticsVariation,
    "aria-label": cta.ariaLabel
  }, others), cta.label)), isAlreadyWraped && __jsx(Para, {
    className: "nva-text-card__cta para-cta-wrapper"
  }, __jsx(FakeAnchorStyled, {
    className: styleType == 'heroCarousel' ? '' : 'arrow'
  }, cta.label)));
};
TextCard.defaultProps = {
  className: '',
  styleType: '',
  headingType: 'h1',
  isAlreadyWraped: false
};
export default styled(TextCard).withConfig({
  componentId: "sc-5mwt0n-0"
})(["", ";"], styles);
export { TextCard as TextCardVanilla };